import { render, staticRenderFns } from "./SettingTelemedicine.vue?vue&type=template&id=70c09a1b&scoped=true"
import script from "./SettingTelemedicine.vue?vue&type=script&lang=js"
export * from "./SettingTelemedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c09a1b",
  null
  
)

export default component.exports